export default __webpack_public_path__ + "static/GT-America-Condensed-Black-Italic-9e70ccb0a9ac8c76c0f339b7f400176a.woff2";